import axios from '@/lib/axios'
import {
  buildAdminRequestConfig,
  type OrganizationId,
  type ScopedAdminQueryKey,
} from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  DeliveryRouteContact,
  DeliveryRouteContactInput,
} from './delivery-route-contacts.types'

interface OrganizationScoped {
  organizationId: OrganizationId
}

interface DeliveryRouteContactScope extends OrganizationScoped {
  deliveryRouteContactId: number
}

export async function getDeliveryRouteContacts({
  queryKey: [{ organizationId }],
}: Pick<QueryFunctionContext<ScopedAdminQueryKey>, 'queryKey'>) {
  return (
    (await axios.get<DeliveryRouteContact[]>(
      '/delivery-route-contacts',
      buildAdminRequestConfig({ organizationId })
    )) || []
  )
}

export async function createDeliveryRouteContact({
  organizationId,
  ...values
}: OrganizationScoped & DeliveryRouteContactInput) {
  return axios.post<DeliveryRouteContact>(
    '/delivery-route-contacts',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function updateDeliveryRouteContact({
  organizationId,
  deliveryRouteContactId,
  ...values
}: DeliveryRouteContactScope & DeliveryRouteContactInput) {
  return axios.put<DeliveryRouteContact>(
    `/delivery-route-contacts/${deliveryRouteContactId}`,
    values,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function deleteDeliveryRouteContact({
  organizationId,
  deliveryRouteContactId,
}: DeliveryRouteContactScope) {
  return axios.delete<void>(
    `/delivery-route-contacts/${deliveryRouteContactId}`,
    buildAdminRequestConfig({ organizationId })
  )
}
